import { memo } from 'react';

import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { useTHelper } from 'src/utils/i18n';
import { CheckoutConfirmationTable } from 'src/pages/Checkout/components/common/Table';

type Props = {
  model: CheckoutConfirmationResponseType['GatedLiveStreamSubsection'];
};

export const CheckoutConfirmationGatedLiveStream = memo<Props>(({ model }) => {
  const tHelper = useTHelper('checkout.confirmation.gatedLiveStream');

  const columns = [
    { name: 'Access Code', className: 'left' },
    { name: 'Livestream Access Link', className: 'left' },
  ];

  return (
    <>
      <h2 className="section-header">{tHelper('title')}</h2>
      <div className="card hoverable summary">
        <table className="table word-break-last-td-column">
          <tbody>
            <tr>
              <td className="roboto-medium text-nowrap">{tHelper('accessCodeInstructions')}</td>
              <td>
                {model.Items.length === 1 ? (
                  tHelper('tableText1', { startDateTime: model.StartDateTime })
                ) : (
                  <>
                    {tHelper('tableText2', { singular: model.TicketsTerminology.Singular?.toLowerCase() || '' })}
                    <br />
                    <br />
                    {tHelper('tableText3', { startDateTime: model.StartDateTime })}
                  </>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <CheckoutConfirmationTable columns={columns} data={model.Items}>
        {(item) => (
          <>
            <td className="left">{item.AccessCode}</td>
            <td className="left">
              <a href={item.AccessLink}>{item.AccessLink}</a>
            </td>
          </>
        )}
      </CheckoutConfirmationTable>
    </>
  );
});
